import styled from 'styled-components';
import COLORS from 'shared/constants/colors';

const Container = styled.div`
  margin: 10px 0;
`;
const CountBox = styled.div`
  display: flex;
  justify-content: center;
  @media (max-width: 450px) {
    flex-direction: column;
    align-items: center;
  }
`;
const IBox = styled.a`
  padding: 0 15px;
  margin-bottom: 25px;
  margin-top: 0;
  cursor: pointer;
  max-width: 375px;
  width: 100%;
  color: ${COLORS.BLACK};
  cursor: pointer;
  &:hover {
    color: ${COLORS.BLACK};
  }
`;
const Title = styled.p`
  background-color: ${COLORS.WHITE};
  border-color: #e7eaec;
  border-style: solid solid none;
  border-width: 4px 0px 0;
  margin-bottom: 0;
  padding: 20px 15px 10px;
  position: relative;
  font-size: 14px;
  margin: 0;
  font-weight: bold;
`;
const Content = styled.p`
  background-color: ${COLORS.WHITE};
  padding: 15px 20px 20px 20px;
  border-color: #e7eaec;
  border-image: none;
  border-style: solid solid none;
  border-width: 1px 0px;
  font-size: 30px;
  margin: 0;
  font-weight: 300;
`;

export { Container, CountBox, IBox, Title, Content };
